export const CHART_PRESET_COLORS = [
    '#294AE4',
    '#7FC400',
    '#FF5CB1',
    '#44E6D0',
    '#00AAEB',
    '#BE31E7',
    '#00927E',
    '#ff6900',
    '#ffbe00',
    '#f81d00',
    '#1b3f9c',
    '#539200',
    '#d74480',
    '#00c7ac',
    '#0078bb',
    '#8b38b2',
    '#006a68',
    '#b65000',
    '#d67900',
    '#962919',
];
export const getChartColor = (index) => CHART_PRESET_COLORS[index % CHART_PRESET_COLORS.length];
